var ApplicationAPI = require("../../../../common/api").Application;

var moment = require("moment");

module.exports = function($scope, reportFields) {
  $scope.dict = {};
  $scope.reportFields = reportFields;
  $scope.minDate = moment("2019/10/01", "YYYY MM DD").toISOString();

  $scope.close = function() {
    var action = "cancel";
    $scope.closeThisDialog({ action: action, value: $scope.dict });
  };

  $scope.confirm = function() {
    var action = "confirm";
    $scope.closeThisDialog({ action: action, value: $scope.dict });
  };

  $scope.addParam = function(field) {
    $scope.dict[field.key] = field.value;
  };

  // Get all projects with status 20.
  $scope.init = function() {
    ApplicationAPI.GetApplications("", "20").then(function(result) {
      $scope.applications = result;
    });

    $scope.reportFields.forEach(function(item) {
      if (item.reportFieldType == 9) {
        item.value = "";
        $scope.addParam(item);
      } else if (item.reportFieldType == 10) {
        // Set null for date as can be left blank for fee reports.
        item.value = null;
        $scope.addParam(item);
      }
    });
  };
  $scope.init();
};
